import { render, staticRenderFns } from "./DetailSurveyForm.vue?vue&type=template&id=74e7d4c6&scoped=true"
import script from "./DetailSurveyForm.vue?vue&type=script&lang=js"
export * from "./DetailSurveyForm.vue?vue&type=script&lang=js"
import style0 from "./DetailSurveyForm.vue?vue&type=style&index=0&id=74e7d4c6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e7d4c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74e7d4c6')) {
      api.createRecord('74e7d4c6', component.options)
    } else {
      api.reload('74e7d4c6', component.options)
    }
    module.hot.accept("./DetailSurveyForm.vue?vue&type=template&id=74e7d4c6&scoped=true", function () {
      api.rerender('74e7d4c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/survey_form/dialog/DetailSurveyForm.vue"
export default component.exports